import * as React from 'react';

import { Wrapper, Title, Details } from './PaymentDetails.styled';
import { CreditCard } from 'assets/icons/Icons';
import { Text } from 'components/v2/Typography/Text';
import { useFeatureFlags } from 'hooks/useFeatureFlags/useFeatureFlags';
import { AppointmentProduct, AppointmentType } from 'kb-shared';
import { isCoachingAppointment, isGYNAppointment } from 'kb-shared/utilities/appointment.helper';

export type ProductType = 'REGULAR_APPOINTMENT' | 'REQUIRES_IMMEDIATE_PAYMENT' | 'GYN_APPOINTMENT';

type Props = {
  product: AppointmentProduct<AppointmentType>;
};

export const PaymentDetails = ({ product }: Props) => {
  const { ppCreditCardOptional } = useFeatureFlags();

  const isCoaching = isCoachingAppointment(product?.data);
  const isCoverByHolisticHealth = isCoaching && product?.data?.shouldChargeAtBooking === false;
  const isFreeOfCharge =
    !product || !product.data || product.data.rateCents === 0 || isCoverByHolisticHealth;

  if (isFreeOfCharge) return null;

  let productType: ProductType = 'REGULAR_APPOINTMENT';

  if (product.type === 'appointment') {
    const categoryId = product?.data.category.id;
    const requiresImmediatePayment = isCoaching;
    const isGYN = isGYNAppointment(parseInt(categoryId));

    if (requiresImmediatePayment) {
      productType = 'REQUIRES_IMMEDIATE_PAYMENT';
    } else if (isGYN) {
      productType = 'GYN_APPOINTMENT';
    }
  }

  return (
    <Wrapper>
      <Title>
        <CreditCard /> Payment details
      </Title>
      <Details>
        <Text tag="p" size="md">
          {['GYN_APPOINTMENT', 'REGULAR_APPOINTMENT'].includes(productType) &&
            !ppCreditCardOptional &&
            "We'll need a credit card to hold this appointment for you."}
        </Text>
      </Details>
    </Wrapper>
  );
};
